/* eslint-disable */
import { MiddlewareSync, MiddlewareNext } from "@sa/rep-common";
import { ComponentContextProcessingState } from "@sa/rep-core";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';
import { ComponentContextCreateOptionsBasf } from "../../../shared";
import { dataSourcesService } from "../../../dataFlow";
export const slide31ContextsMiddleware: MiddlewareSync<ComponentContextProcessingState> = (input, next) => {
  if (REPORT_ID === input.identification.reportId) {
    const options = input.createOptions as ComponentContextCreateOptionsBasf;
    if (options) {
      options.dataSourcesService = dataSourcesService;
    }
    const context = new SlideContext(input.identification.componentId, options);
    input.componentContext = context;
  }
  return next(input);
};
